// extracted by mini-css-extract-plugin
export default {"scroll-to-top":"ScrollToTop_scroll-to-top__vOvkB"};